export const environment = {
        ENV : 'LOCAL',
        VERSION:'1.000',
        PRODUCTION: false,
        LOGO_URL: '',
        DEMO_APP_SIGNATURE_CERT_PRIVATE_KEY: '',
        BASE_API_URL:'https://qms-auth-service-dev.i2itechsolutions.com/api/v1/qms',
        SYN_LICENCE_KEY: 'Ngo9BigBOggjHTQxAR8/V1NBaF5cXmZCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWXpccHRSRWNfUEJwX0Y=',
        version:'1.0.0',
        company:'SWAAS',
        LOGO:'https://swaasitsolutions.azureedge.net/swaas/images/swaas_logo.webp',

};
